import React from 'react';
import GlassType from '../../controls/glass/GlassType';
import TexturedDesign from '../../controls/glass/TexturedDesign';
import TintedDesign from '../../controls/glass/TintedDesign';
import GlazingType from '../../controls/glass/GlazingType';
import GlassEnergy from '../../controls/glass/GlassEnergy';
import NeatGlass from '../../controls/glass/NeatGlass';
import GlassStrength from '../../controls/glass/GlassStrength';
import GlassThickness from '../../controls/glass/GlassThickness';
import { minmaxWindow } from '../../../lib/minmax';

export const getGlassSection = (props) => {
  const {
    SECTIONS,
    isDisabled,
    glassTypeValue1, setGlassTypeValue1,
    texturedDesignValue1, setTexturedDesignValue1,
    tintedDesignValue1, setTintedDesignValue1,
    glazingTypeValue1, setGlazingTypeValue1,
    glassEnergyValue1, setGlassEnergyValue1,
    neatGlassValue1, setNeatGlassValue1,
    glassStrengthValue1, setGlassStrengthValue1,
    glassThicknessValue1, setGlassThicknessValue1,
    windowTypeValue1,
    setMinMaxW,
  } = props;

  return [
    // Glass section starts ...
    { id: "GlassType1",  component: 1 > SECTIONS ? null : ( <GlassType
        disabled={isDisabled} id = {"GlassType1"} label={"Glass"}
        value={glassTypeValue1}  onChange={(newValue) => { setGlassTypeValue1(newValue);}
    }/>),   position: [1, 1], status: "active", expandableSectionId: "Glass" },


    (glassTypeValue1.label === "Textured") &&
    { id: "TexturedDesign1",  component: 1 > SECTIONS ? null : ( <TexturedDesign
      disabled={isDisabled} id = {"TexturedDesign1"} label={"Textured Design"}
      value={texturedDesignValue1}  onChange={(newValue) => { setTexturedDesignValue1(newValue);}
    }/>),   position: [1, 2], status: "active", expandableSectionId: "Glass" },


    (glassTypeValue1.label === "Tinted") &&
    { id: "TintedDesign1",  component: 1 > SECTIONS ? null : ( <TintedDesign
      disabled={isDisabled} id = {"TintedDesign1"} label={"Tinted Design"}
      value={tintedDesignValue1}  onChange={(newValue) => { setTintedDesignValue1(newValue);}
    }/>),   position: [1,2], status: "active", expandableSectionId: "Glass" },

    { id: "GlazingType1",  component: 1 > SECTIONS ? null : ( <GlazingType
      disabled={isDisabled} id = {"GlazingType1"} label={"Glazing Type"}
      value={glazingTypeValue1}  onChange={(newValue) => { setGlazingTypeValue1(newValue); setMinMaxW(minmaxWindow(windowTypeValue1,newValue));}
    }/>),   position: [2,1], status: "active", expandableSectionId: "Glass" },

    { id: "GlassEnergy1",  component: 1 > SECTIONS ? null : ( <GlassEnergy
      disabled={isDisabled} id = {"GlassEnergy1"} label={"Glass Energy"}
      value={glassEnergyValue1}  onChange={(newValue) => { setGlassEnergyValue1(newValue);}
    }/>),   position: [2,2], status: "active", expandableSectionId: "Glass" },

    { id: "NeatGlass1",  component: 1 > SECTIONS ? null : ( <NeatGlass
      disabled={isDisabled} id = {"NeatGlass1"} label={"Neat Glass"}
      value={neatGlassValue1}  onChange={(newValue) => { setNeatGlassValue1(newValue);}
    }/>),   position: [2,3], status: "active", expandableSectionId: "Glass" },

    { id: "GlassStrength1",  component: 1 > SECTIONS ? null : ( <GlassStrength
      disabled={isDisabled} id = {"GlassStrength1"} label={"Glass Strength"}
      value={glassStrengthValue1}  onChange={(newValue) => { setGlassStrengthValue1(newValue);}
    }/>),   position: [3,1], status: "active", expandableSectionId: "Glass" },

    { id: "GlassThickness1",  component: 1 > SECTIONS ? null : ( <GlassThickness
      disabled={isDisabled} id = {"GlassThickness1"} label={"Glass Thickness"}
      value={glassThicknessValue1}  onChange={(newValue) => { setGlassThicknessValue1(newValue);}
    }/>),   position: [3,2], status: "active", expandableSectionId: "Glass" },

    // Glass ends ...
  ];
};
